import { createFeatureSelector, createSelector } from '@ngrx/store';
import { FeatureFlagValue } from '../../types/feature-flag-value.type';
import { FeatureFlagsState, featureFlagsStoreKey } from '../models/feature-flags-state.model';

const selectFeatureFlagsState = createFeatureSelector<FeatureFlagsState>(featureFlagsStoreKey);

const isActive = (key: string, expectedValue: FeatureFlagValue = true) =>
  createSelector(selectFeatureFlagsState, (state) => {
    if (!key) return true;
    const value = state?.flags[key];
    return value === expectedValue;
  });

const getActive = createSelector(selectFeatureFlagsState, (state) => {
  return Object.keys(state.flags).filter((key) => !!state.flags[key]);
});

const initialized = createSelector(selectFeatureFlagsState, (state) => state?.initialized);

// 新增：检查当前 storeId 是否在 flag 的允许列表中
const isActiveForStore = (key: string, storeId: string | undefined | null) =>
  createSelector(selectFeatureFlagsState, (state) => {
    if (!key) return false;

    const value = state?.flags[key];

    // 如果 flag 值是数组
    if (Array.isArray(value)) {
      // 检查是否包含通配符 "*" (表示所有店铺)
      if (value.includes('*')) {
        return true;
      }

      // 特殊情况：All Stores - 如果数组不为空，则显示
      if (storeId === 'ALL_STORES') {
        return value.length > 0; // 只要有任意店铺有权限就显示
      }

      // 正常情况：检查特定 storeId 是否在数组中
      if (storeId) {
        return value.includes(storeId);
      }

      return false;
    }

    // 降级：如果是 boolean 类型（兼容旧版本）
    return value === true;
  });

export const featureFlagsSelectors = {
  isActive,
  isActiveForStore,
  getActive,
  initialized,
};
